import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { HospitalInfo } from '../hospital-info/HospitalInfo';
import { User } from '../user/User';

/**
 * # Patient
 *
 * 환자 모델
 */

export const PrescriptionCode = types.model('PrescriptionCode', {
  prescriptionId: types.maybeNull(types.string),
  userNm: types.maybeNull(types.string),
  birthday: types.maybeNull(types.string),
  phoneNo: types.maybeNull(types.string),
  hsptlSid: types.maybeNull(types.number),
  registerYn: types.maybeNull(types.string),
  regDt: types.maybeNull(types.string),
  updId: types.maybeNull(types.string),
  hsptlInfo: types.maybeNull(HospitalInfo),
});
type TPrescriptionCode = Instance<typeof PrescriptionCode>;
export interface IPrescriptionCode extends TPrescriptionCode {}
export const createPrescriptionCode = () =>
  types.optional(PrescriptionCode, {} as TPrescriptionCode);

export const Patient = types
  .model('Patient')
  // --------------------------------------------------------------------------
  .props({
    user: types.maybeNull(User),
    prescriptionCode: types.maybeNull(PrescriptionCode),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model patient --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IPatient;
      (Object.keys(newProps) as TPatientKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TPatient = Instance<typeof Patient>;
type TPatientSnapshot = SnapshotOut<typeof Patient>;

export interface IPatient extends TPatient {}
export type TPatientKeys = keyof TPatientSnapshot & string;
export interface IPatientSnapshot extends TPatientSnapshot {}
export const createPatient = () => types.optional(Patient, {} as TPatient);
